'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receivedChatHistory = exports.requestedChatHistoryFailed = exports.requestedChatHistory = undefined;
exports.fetchChatHistory = fetchChatHistory;
exports.fetchPublicChatHistory = fetchPublicChatHistory;
exports.fetchInitialPublicChatHistory = fetchInitialPublicChatHistory;

var _reduxActions = require('redux-actions');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _immutable = require('immutable');

var _MessagesClient = require('conversations-core/data/MessagesClient');

var _PubNubMessageModel = require('conversations-schema/models/PubNubMessageModel');

var _PubNubMessageFactory = require('conversations-schema/factories/PubNubMessageFactory');

var _clientSelectors = require('conversations-core/selectors/clientSelectors');

var _widgetDataSelectors = require('conversations-core/selectors/widgetDataSelectors');

var _pubNubHelpers = require('conversations-core/utils/pubNubHelpers');

var _strings = require('conversations-core/constants/strings');

var _PublishActions = require('conversations-core/actions/PublishActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prepareMessageRecords = function prepareMessageRecords(history, offsetInMs) {
  return new _immutable.OrderedSet(history.messages.map(function (props) {
    return (0, _PubNubMessageModel.applyTimestampOffset)(-offsetInMs, (0, _PubNubMessageFactory.buildPublishedMessage)(props));
  }));
};

var requestedChatHistory = exports.requestedChatHistory = (0, _reduxActions.createAction)(_ActionTypes2.default.GET_CHAT_HISTORY, function (channel) {
  return { channel: channel };
});

var requestedChatHistoryFailed = exports.requestedChatHistoryFailed = (0, _reduxActions.createAction)(_ActionTypes2.default.GET_CHAT_HISTORY_FAILED, function (channel, error) {
  return {
    channel: channel,
    error: error
  };
});

var receivedChatHistory = exports.receivedChatHistory = (0, _reduxActions.createAction)(_ActionTypes2.default.GET_CHAT_HISTORY_SUCCEEDED, function (channel, history, offsetInMs) {
  var messageRecords = prepareMessageRecords(history, offsetInMs);
  return {
    channel: channel,
    messages: messageRecords,
    startTime: (0, _pubNubHelpers.getTimestampFromToken)(history.startTimetoken),
    endTime: (0, _pubNubHelpers.getTimestampFromToken)(history.endTimetoken)
  };
});

function fetchChatHistory(_ref) {
  var channel = _ref.channel,
      startTime = _ref.startTime;

  return function (dispatch, getState) {
    var offsetInMs = (0, _clientSelectors.getServerTimeOffsetInMs)(getState());
    var offsetStartTime = startTime + offsetInMs;

    dispatch(requestedChatHistory(channel));
    (0, _MessagesClient.fetchChatHistoryChunk)({ channel: channel, startTime: offsetStartTime }).then(function (history) {
      dispatch(receivedChatHistory(channel, history, offsetInMs));
    }, function (err) {
      dispatch(requestedChatHistoryFailed(channel, err));
    }).done();
  };
}

function fetchPublicChatHistory(_ref2) {
  var channel = _ref2.channel,
      startTime = _ref2.startTime;

  return function (dispatch, getState) {
    var offsetInMs = (0, _clientSelectors.getServerTimeOffsetInMs)(getState());
    var sessionId = (0, _widgetDataSelectors.getSessionId)(getState());
    var offsetStartTime = startTime + offsetInMs;

    dispatch(requestedChatHistory(channel));
    (0, _MessagesClient.fetchPublicChatHistoryChunk)({ sessionId: sessionId, startTime: offsetStartTime }).then(function (history) {
      dispatch(receivedChatHistory(channel, history, offsetInMs));
    }, function (err) {
      dispatch(requestedChatHistoryFailed(channel, err));
    }).done();
  };
}

function fetchInitialPublicChatHistory() {
  return function (dispatch, getState) {
    var sessionId = (0, _widgetDataSelectors.getSessionId)(getState());
    var startTime = Date.now();
    var channel = _strings.INITIAL_ONLINE_MODE_CHANNEL;
    var initialOffset = 0;

    dispatch(requestedChatHistory(channel));
    (0, _MessagesClient.fetchPublicChatHistoryChunk)({ sessionId: sessionId, startTime: startTime }).then(function (history) {
      dispatch(receivedChatHistory(channel, history, initialOffset));

      if (history.messages.length === 0) {
        dispatch((0, _PublishActions.publishInitialMessage)());
      }
    }, function (err) {
      dispatch(requestedChatHistoryFailed(channel, err));
    }).done();
  };
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/actions/ChatHistoryActions.js
// module id = 151
// module chunks = 0 1